export default {
  isConnected: false,
}
